// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as OrderStatus from "../../../../../../library/data-source/order/entity/OrderStatus.bs.js";
import * as PaymentMode from "../../../../../../library/data-source/order/entity/PaymentMode.bs.js";
import * as FareStrategy from "../entity/FareStrategy.bs.js";
import * as OrderApiModel from "../api-model/OrderApiModel.bs.js";
import * as DeliveryNoteType from "../../../../../../library/data-source/order/entity/DeliveryNoteType.bs.js";
import * as DeliveryNoteStatus from "../../../../../../library/data-source/order/entity/DeliveryNoteStatus.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as BreachInfoThreshold from "../../../../../../library/data-source/order/entity/BreachInfoThreshold.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function resolveOption(value, key) {
  if (value !== undefined) {
    return Caml_option.valFromOption(value);
  } else {
    return Curry._1(ErrorUtils$Catalyst.raiseError("OrderEntityMapper.re", key + " not found", undefined), undefined);
  }
}

function decodeCustomerInfo(customer_info) {
  return {
          customer_id: customer_info.customer_id,
          customer_mobile: customer_info.contact.number,
          name: customer_info.contact.name
        };
}

function decodeLocation($$location) {
  return {
          place: {
            landmark: $$location.place.full_address,
            doorstep_address: Belt_Option.getWithDefault($$location.place.doorstep_address, ""),
            location: {
              lat: $$location.place.location.lat,
              lng: $$location.place.location.long
            }
          },
          contact: {
            name: $$location.contact.name,
            number: $$location.contact.number
          }
        };
}

function decodeVehicle(vehicle) {
  return {
          vehicle_id: vehicle.vehicle_id,
          vehicle_type: vehicle.vehicle_type,
          size: vehicle.size,
          capacity: vehicle.capacity
        };
}

function decodeDeliveryNote(delivery_note) {
  if (delivery_note === undefined) {
    return ;
  }
  var tmp;
  if (List.length(delivery_note.details) > 1) {
    tmp = {
      is_requested: delivery_note.is_requested,
      hardcopy_status: DeliveryNoteStatus.fromString(List.find((function (detail) {
                  return detail.dn_type === "HARDCOPY";
                }), delivery_note.details).status),
      softcopy_status: DeliveryNoteStatus.fromString(List.find((function (detail) {
                  return detail.dn_type === "SOFTCOPY";
                }), delivery_note.details).status),
      dn_types: List.map((function (detail) {
              return DeliveryNoteType.fromString(detail.dn_type);
            }), delivery_note.details)
    };
  } else {
    var dn_detail = List.hd(delivery_note.details);
    var match = dn_detail.dn_type;
    var tmp$1 = match === "HARDCOPY" ? DeliveryNoteStatus.fromString(dn_detail.status) : undefined;
    var match$1 = dn_detail.dn_type;
    var tmp$2 = match$1 === "SOFTCOPY" ? DeliveryNoteStatus.fromString(dn_detail.status) : undefined;
    tmp = {
      is_requested: delivery_note.is_requested,
      hardcopy_status: tmp$1,
      softcopy_status: tmp$2,
      dn_types: {
        hd: DeliveryNoteType.fromString(dn_detail.dn_type),
        tl: /* [] */0
      }
    };
  }
  return tmp;
}

function getDecodedCommonOrder(order_details) {
  var delivery_instructions = order_details.booking_info.delivery_instructions;
  return {
          business_type: order_details.booking_info.order_type,
          customer_info: decodeCustomerInfo(order_details.booking_info.customer),
          distance: order_details.booking_info.distance,
          drop_info: Belt_Option.mapWithDefault(order_details.booking_info.drop_location, undefined, (function (l) {
                  return decodeLocation(l);
                })),
          geo_region_id: order_details.booking_info.geo_region_id,
          geo_region_name: order_details.booking_info.geo_region_name,
          has_waypoints: order_details.booking_info.has_waypoints,
          additional_waypoints_allowed: order_details.booking_info.additional_waypoints_allowed,
          additional_waypoints_eligible: order_details.booking_info.additional_waypoints_eligible,
          is_postpaid: true,
          order_id: order_details.order_info.order_id,
          order_crn: order_details.order_info.order_crn,
          order_updated_at: order_details.order_info.order_updated_at,
          payment_mode: PaymentMode.fromString(order_details.booking_info.payment_mode),
          pickup_info: decodeLocation(order_details.booking_info.pickup_location),
          scheduled_pickup_time: Timestamp$Catalyst.make(order_details.order_info.pickup_time),
          status: OrderStatus.fromString(order_details.order_info.status),
          vehicle: decodeVehicle(order_details.booking_info.vehicle),
          order_invoice_url: Belt_Option.mapWithDefault(order_details.status_info.completed_order_info, undefined, (function (o) {
                  return Belt_Option.mapWithDefault(o.order_invoice_url, undefined, (function (url) {
                                return url;
                              }));
                })),
          is_helper_order: order_details.vas_services.is_helper_order,
          is_helper_plus_labour: order_details.vas_services.is_helper_plus_labour_order,
          is_otp_order: order_details.miscellaneous_info.is_otp_order,
          is_pfe_order: order_details.miscellaneous_info.is_business_order,
          waypoints: List.map(decodeLocation, order_details.booking_info.waypoints),
          is_outstation_order: order_details.miscellaneous_info.is_outstation_order,
          is_rental_order: order_details.miscellaneous_info.is_rental_order,
          goods_type: order_details.booking_info.goods_type,
          goods_type_id: order_details.booking_info.goods_type_id,
          from_state: order_details.booking_info.from_state,
          to_state: order_details.booking_info.to_state,
          created_at: Timestamp$Catalyst.make(order_details.booking_info.created_at),
          order_source: order_details.booking_info.order_source,
          booking_type: order_details.booking_info.order_type,
          pickup_time: Timestamp$Catalyst.make(order_details.order_info.pickup_time),
          create_trip_fare_strategy: Belt_Option.mapWithDefault(order_details.status_info.unallocated_order_info.create_trip_fare_strategy, undefined, (function (c) {
                  return FareStrategy.CreateTrip.fromString(c);
                })),
          delivery_instructions: delivery_instructions !== undefined ? List.map((function (item) {
                    return item.description;
                  }), delivery_instructions.instructions_list) : /* [] */0,
          delivery_note: decodeDeliveryNote(order_details.booking_info.delivery_note),
          is_order_editable: Belt_Option.mapWithDefault(order_details.order_editability, undefined, (function (o) {
                  return o.is_editable;
                }))
        };
}

function decodePartnerInfo(partner_info) {
  return {
          name: partner_info.name,
          mobile: partner_info.mobile,
          has_nep: partner_info.has_nep,
          vehicle_number: partner_info.vehicle_number,
          vehicle_type: partner_info.vehicle_type,
          msisdn: partner_info.driver_msisdn,
          secondary_mobile: partner_info.partner_secondary_mobile,
          fuel_type: partner_info.fuel_type
        };
}

function getDecodedAcceptedOrder(order_details) {
  var accepted_order = order_details.status_info.accepted_order_info;
  if (accepted_order !== undefined) {
    return {
            partner_info: decodePartnerInfo(resolveOption(order_details.partner_info, "order_details.partner_info")),
            trip_accepted_time: Belt_Option.mapWithDefault(accepted_order.trip_accepted_time, undefined, (function (time) {
                    return Caml_option.some(Timestamp$Catalyst.make(time));
                  })),
            accepted_location: Belt_Option.mapWithDefault(accepted_order.trip_accepted_location, undefined, (function (v) {
                    return {
                            lat: v.lat,
                            long: v.long
                          };
                  })),
            driver_location_accuracy: accepted_order.driver_location_accuracy
          };
  } else {
    return Curry._1(ErrorUtils$Catalyst.raiseError("OrderEntityMapper.re", " key accepted_order_info not found", undefined), undefined);
  }
}

function getDecodedLiveOrder(order_details) {
  var live_order = order_details.status_info.live_order_info;
  if (live_order !== undefined) {
    return {
            trip_started_time: Timestamp$Catalyst.make(live_order.trip_started_time),
            start_location: Belt_Option.mapWithDefault(live_order.trip_started_location, undefined, (function (l) {
                    return l.full_address;
                  })),
            start_lat_long: Belt_Option.map(Belt_Option.flatMap(live_order.trip_started_location, (function (l) {
                        return l.location;
                      })), (function (v) {
                    return {
                            lat: v.lat,
                            long: v.long
                          };
                  }))
          };
  } else {
    return Curry._1(ErrorUtils$Catalyst.raiseError("OrderEntityMapper.re", " key live_order_info not found", undefined), undefined);
  }
}

function getDecodedCancelledOrder(order_details) {
  var cancelled_order = order_details.status_info.cancelled_order_info;
  if (cancelled_order !== undefined) {
    return {
            partner_info: Belt_Option.mapWithDefault(order_details.partner_info, undefined, (function (p) {
                    return decodePartnerInfo(p);
                  })),
            cancellation_reason: cancelled_order.cancellation_reason,
            trip_cancelled_time: Timestamp$Catalyst.make(cancelled_order.trip_cancelled_time),
            cancellation_source: cancelled_order.cancellation_source,
            is_penalty_applied: cancelled_order.is_penalty_applied
          };
  } else {
    return Curry._1(ErrorUtils$Catalyst.raiseError("OrderEntityMapper.re", " key cancelled_order_info not found", undefined), undefined);
  }
}

function getDecodedBreachInfo(breach_info) {
  return {
          breach_type: breach_info.breach_type,
          drop_vicinity_passed: BreachInfoThreshold.fromString(Belt_Option.mapWithDefault(breach_info.drop_vicinity_passed, "na", (function (v) {
                      return v;
                    }))),
          waypoint_vicinity_passed: BreachInfoThreshold.fromString(Belt_Option.mapWithDefault(breach_info.waypoint_vicinity_passed, "na", (function (v) {
                      return v;
                    }))),
          fixed_fallback_fare_is_higher: breach_info.fixed_fallback_fare_is_higher,
          pickup_vicinity_passed: BreachInfoThreshold.fromString(Belt_Option.mapWithDefault(breach_info.pickup_vicinity_passed, "na", (function (v) {
                      return v;
                    }))),
          waiting_time_passed: BreachInfoThreshold.fromString(Belt_Option.mapWithDefault(breach_info.waiting_time_passed, "na", (function (v) {
                      return v;
                    })))
        };
}

function getDecodedEndedOrder(order_details) {
  var ended_order = order_details.status_info.ended_order_info;
  if (ended_order !== undefined) {
    return {
            trip_end_time: Timestamp$Catalyst.make(ended_order.trip_ended_time),
            trip_ended_location: Belt_Option.mapWithDefault(ended_order.trip_ended_location, undefined, (function (l) {
                    return l.full_address;
                  })),
            trip_ended_lat_long: Belt_Option.map(Belt_Option.flatMap(ended_order.trip_ended_location, (function (l) {
                        return l.location;
                      })), (function (v) {
                    return {
                            lat: v.lat,
                            long: v.long
                          };
                  })),
            breach_info: Belt_Option.mapWithDefault(ended_order.breach_info, undefined, (function (b) {
                    return getDecodedBreachInfo(b);
                  })),
            is_return_trip: ended_order.is_return_trip,
            job_end_time: Belt_Option.mapWithDefault(order_details.status_info.completed_order_info, undefined, (function (t) {
                    return Caml_option.some(Timestamp$Catalyst.make(t.trip_completed_time));
                  })),
            customer_rating: Belt_Option.mapWithDefault(order_details.status_info.completed_order_info, undefined, (function (t) {
                    return t.customer_rating;
                  })),
            dry_run_distance: ended_order.dry_run_distance,
            dry_run_duration: ended_order.dry_run_duration,
            end_trip_fare_strategy: Belt_Option.mapWithDefault(ended_order.end_trip_fare_strategy, undefined, (function (c) {
                    return FareStrategy.EndTrip.fromString(c);
                  })),
            previous_due: Currency.toCurrency(ended_order.previous_due),
            tax_on_commision: Currency.toCurrency(Belt_Option.mapWithDefault(ended_order.tax_on_commision, 0.0, (function (t) {
                        return t;
                      })))
          };
  } else {
    return Curry._1(ErrorUtils$Catalyst.raiseError("OrderEntityMapper.re", " key ended_order_info not found", undefined), undefined);
  }
}

function getDecodedCompletedOrder(order_details) {
  var completed_order = order_details.status_info.completed_order_info;
  if (completed_order !== undefined) {
    return {
            trip_completed_time: Timestamp$Catalyst.make(completed_order.trip_completed_time),
            customer_rating: Belt_Option.getWithDefault(completed_order.customer_rating, ""),
            order_invoice_url: completed_order.order_invoice_url
          };
  } else {
    return Curry._1(ErrorUtils$Catalyst.raiseError("OrderEntityMapper.re", " key completed_order_info not found", undefined), undefined);
  }
}

function execute(json) {
  var o = DeccoUtils$Catalyst.resolveResult(OrderApiModel.order_details_decode(json), "OrderEntityMapper.re");
  var order_details = o.order_details;
  var order_status = OrderStatus.fromString(order_details.order_info.status);
  var exit = 0;
  switch (order_status) {
    case /* Open */0 :
    case /* Allocated */1 :
        return {
                TAG: /* Open */0,
                _0: getDecodedCommonOrder(order_details)
              };
    case /* Accepted */2 :
        return {
                TAG: /* Accepted */1,
                _0: getDecodedCommonOrder(order_details),
                _1: getDecodedAcceptedOrder(order_details)
              };
    case /* Live */3 :
    case /* Loading */4 :
    case /* Unloading */5 :
        exit = 1;
        break;
    case /* Ended */6 :
    case /* Completed */7 :
        exit = 3;
        break;
    case /* Cancelled */8 :
    case /* Rescheduled */9 :
        exit = 2;
        break;
    
  }
  switch (exit) {
    case 1 :
        return {
                TAG: /* Live */2,
                _0: getDecodedCommonOrder(order_details),
                _1: getDecodedAcceptedOrder(order_details),
                _2: getDecodedLiveOrder(order_details)
              };
    case 2 :
        var match = order_details.status_info.accepted_order_info;
        var match$1 = order_details.status_info.live_order_info;
        var match$2 = order_details.status_info.ended_order_info;
        var match$3 = order_details.status_info.completed_order_info;
        var exit$1 = 0;
        var exit$2 = 0;
        if (match !== undefined) {
          if (match$1 !== undefined) {
            if (match$2 !== undefined) {
              exit$2 = 5;
            } else {
              if (match$3 === undefined) {
                return {
                        TAG: /* CancelledLive */6,
                        _0: getDecodedCommonOrder(order_details),
                        _1: getDecodedCancelledOrder(order_details),
                        _2: getDecodedAcceptedOrder(order_details),
                        _3: getDecodedLiveOrder(order_details)
                      };
              }
              exit$2 = 5;
            }
          } else if (match$2 !== undefined) {
            exit$2 = 5;
          } else {
            if (match$3 === undefined) {
              return {
                      TAG: /* CancelledAccepted */5,
                      _0: getDecodedCommonOrder(order_details),
                      _1: getDecodedCancelledOrder(order_details),
                      _2: getDecodedAcceptedOrder(order_details)
                    };
            }
            exit$2 = 5;
          }
        } else if (match$1 !== undefined || match$2 !== undefined) {
          exit$2 = 5;
        } else {
          if (match$3 === undefined) {
            return {
                    TAG: /* Cancelled */4,
                    _0: getDecodedCommonOrder(order_details),
                    _1: getDecodedCancelledOrder(order_details)
                  };
          }
          exit$2 = 5;
        }
        if (exit$2 === 5) {
          if (match$2 !== undefined) {
            if (match$3 === undefined) {
              return {
                      TAG: /* CancelledEnded */8,
                      _0: getDecodedCommonOrder(order_details),
                      _1: getDecodedLiveOrder(order_details),
                      _2: getDecodedAcceptedOrder(order_details),
                      _3: getDecodedCancelledOrder(order_details),
                      _4: getDecodedEndedOrder(order_details)
                    };
            }
            exit$1 = 4;
          } else {
            if (match$3 === undefined) {
              return Curry._1(ErrorUtils$Catalyst.raiseError("OrderEntityMapper.re", "Accepted order missing for live cancelled order", undefined), undefined);
            }
            exit$1 = 4;
          }
        }
        if (exit$1 === 4) {
          return {
                  TAG: /* CancelledCompleted */7,
                  _0: getDecodedCommonOrder(order_details),
                  _1: getDecodedLiveOrder(order_details),
                  _2: getDecodedAcceptedOrder(order_details),
                  _3: getDecodedCancelledOrder(order_details),
                  _4: getDecodedEndedOrder(order_details),
                  _5: getDecodedCompletedOrder(order_details)
                };
        }
        break;
    case 3 :
        return {
                TAG: /* Ended */3,
                _0: getDecodedCommonOrder(order_details),
                _1: getDecodedAcceptedOrder(order_details),
                _2: getDecodedLiveOrder(order_details),
                _3: getDecodedEndedOrder(order_details)
              };
    
  }
}

export {
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
